import { FormHelperService } from '@services/form-helper.service';
import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    OnInit,
    ViewChild
} from '@angular/core';
import {BaseFieldComponent} from '../base-field.component';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';

@Component({
    selector: 'app-form-input',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <input #inputElement [type]="type"
               [attr.name]="name"
               [formControl]="fbControl"
               class="form-element _{{rowPosition}} {{(isPassword || resetButton) ? '_password' : ''}}"
               [class.form-element--small]="small"
               [placeholder]="placeholder"
               [appInputmask]="inputmask"
               (blur)="blur.emit()"
               [maxlength]="maxLength || null"
               [appValidateOnBlur]="validateOnBlur">
        <ng-content></ng-content>
        <span *ngIf="isPassword" class="form-element__password-toggle" (click)="togglePassword()">
            <lib-icon type="eye"></lib-icon>
        </span>
        <span *ngIf="resetButton && hasValue()" class="form-element__password-toggle" (click)="resetValue()">
            <lib-icon type="cross"></lib-icon>
        </span>
    `,
    styles: [`
        :host {
            display: block;
            position: relative;
        }

        input._password {
            padding-right: 45px;
            position: relative;
        }
    `]
})

export class FormInputComponent extends BaseFieldComponent implements OnInit, AfterViewInit {
    @Input() placeholder = '';
    @Input() type = 'text';
    @Input() name = null;
    @Input() hasName = true;
    @Input() inputmask: string;
    @Input() isPassword = false;
    @Input() maxLength: number;
    @Input() resetButton = false;
    @Input() small = false;
    @Input() autofocus = false;

    /**
     * Если эдементы стоят в сроку, то можно добавить класс для CSS, указав позицию
     */
    @Input() rowPosition: 'left' | 'center' | 'right';

    @ViewChild('inputElement') private inputElement: ElementRef<HTMLInputElement>;

    constructor(
        private cd: ChangeDetectorRef,
    ) {
        super();
    }

    ngOnInit() {
        super.ngOnInit();
        if (this.isPassword) {
            this.type = 'password';
        }

        if (this.hasName && !this.name) {
            this.name = FormHelperService.getControlName(this.fbControl);
        }

        this.subs.push(
            this.fbControl.statusChanges.pipe(
                debounceTime(30),
                distinctUntilChanged(),
            ).subscribe(() => {
                this.cd.detectChanges();
            })
        );
    }

    ngAfterViewInit(): void {
        if (this.autofocus) {
            this.cd.detectChanges();
            /**
             * @TODO Без SetTimeout пока никак
             * Модалка, которая отображается с прелоадером, если в ней есть элемент автофокуса,
             * рендерит контент позже, чем срабатывает данный хук, поэтому таким костылем
             * мы обеспечиваем автофокус для элементов внутри таких модалок
             * Например, используется для поля "Количество" формы параметров контроля заключения
             */
            setTimeout(() => {
                if (this.inputElement && this.inputElement.nativeElement) {
                    this.inputElement.nativeElement.focus();
                }
            }, 0);
        }
    }

    togglePassword() {
        if (!this.isPassword) {
            return;
        }

        this.type = this.type === 'password' ? 'text' : 'password';
    }

    hasValue() {
        return Boolean(this.fbControl.value);
    }

    resetValue() {
        this.fbControl.patchValue('');
        this.fbControl.markAsDirty();
        this.fbControl.markAsTouched();
        this.fbControl.updateValueAndValidity();
    }
}
